import { useEffect, useState } from "react";

export interface FilterItem<T> {
  field?: string;
  value?: T;
}

export interface IWithFilter<T> extends FilterItem<T> {
  onFilterChange?: (filter: FilterItem<T>) => void;
}

function useWithFilter<T>({ field, value, onFilterChange }: IWithFilter<T>) {
  const [state, setState] = useState({
    field,
    value
  });

  const handleFilterChange = (newValue: T) => {
    setState(prevState => {
      const newState = { ...prevState, value: newValue };
      onFilterChange?.(newState);
      return newState;
    });
  };

  useEffect(() => {
    setState({ field, value });
  }, [field, value]);

  return { state, handleFilterChange };
}

export default useWithFilter;
